import React from "react";
import PropTypes from "prop-types";

const Statuses = ({ selectClassName, value, onChange, statusTitle }) => (
  <div className={selectClassName}>
    <select
      className="form-control"
      value={value}
      onChange={onChange}
      {...(statusTitle ? { "title": statusTitle } : {})}
      aria-label={statusTitle || "Select status"}
    >
      <option value="current">
        Current
      </option>
      <option value="future">
        Future
      </option>
      {/* In Service is using this too. */}
      <option value="completed">
        Past
      </option>
    </select>
  </div>
);

Statuses.propTypes = {
  selectClassName: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func
};

Statuses.defaultProps = {
  selectClassName: "col-md-2 col-xs-12",
  value: "currents",
  onChange: null
};

export default Statuses;
